var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ico Custom Customer",
    viewBox: "0 0 14 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".customer-icon-1{fill:currentColor}.customer-icon-2,.customer-icon-4{fill:none}.customer-icon-2{stroke:currentColor;stroke-width:2px}.customer-icon-3{stroke:none}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(2.833 3.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1988"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(2.833 6.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1993"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(2.833 9.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1996"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(5.833 3.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1989"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(5.833 6.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1992"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(5.833 9.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1995"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(8.833 3.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1990"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(8.833 6.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1991"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "customer-icon-1",
    transform: "translate(8.833 9.449)",
    cx: 1,
    cy: 1,
    r: 1,
    "data-name": "Ellipse 1994"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "customer-icon-2",
    "data-name": "Rechteck 135019"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customer-icon-3",
    d: "M0 0h9a5 5 0 0 1 5 5v14H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "customer-icon-4",
    d: "M2 1h7a4 4 0 0 1 4 4v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customer-icon-1",
    transform: "translate(5 13)",
    d: "M0 0h4v4H0z",
    "data-name": "Rechteck 135415"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.4899888564684d26e81ffbbb386ddeab.svg";
export { ForwardRef as ReactComponent };